import { ReactNode } from 'react';
import InfoText from './InfoText';
import Logo from '../../assets/icons/Logo';

import { CloseCircle } from 'iconsax-react';

export default function ModalHeader({
  title,
  description,
  onClose,
  closable = true,
  withoutLogo = false,
  variant = 'default',
}: {
  title: string | ReactNode;
  description?: string | ReactNode;
  onClose?: () => void;
  closable?: boolean;
  withoutLogo?: boolean;
  variant?: 'default' | 'supplier';
}) {
  return (
    <div
      className={
        variant === 'supplier'
          ? 'flex flex-col gap-1 mb-4 md:gap-4'
          : 'space-y-2'
      }
    >
      <div
        className={`flex items-center ${variant === 'supplier' && withoutLogo ? 'justify-center' : 'justify-between'}`}
      >
        <div className="flex items-center gap-3">
          {!withoutLogo &&
            (variant === 'supplier' ? (
              <Logo className="w-[35px] md:w-[50px]" />
            ) : (
              <Logo size={45} />
            ))}
          {variant === 'supplier' ? (
            <h3 className="text-light-text-primary dark:text-dark-text-primary text-xl font-semibold md:text-2xl">
              {title}
            </h3>
          ) : typeof title === 'string' ? (
            <InfoText
              text={title}
              size="2xl"
              className="!font-bold !text-light-button-primary dark:!text-dark-text-primary"
            />
          ) : (
            title
          )}
        </div>
        {closable && onClose && (
          <button
            type="button"
            className="border-8 border-light-text-placeholder border-opacity-10 rounded-full p-0 flex items-center justify-center transition-opacity hover:opacity-80"
            onClick={onClose}
          >
            <CloseCircle
              size="20"
              variant="Bold"
              className="dark:text-light-surface-primary"
            />
          </button>
        )}
      </div>

      {description &&
        (variant === 'supplier' && typeof description === 'string' ? (
          <p className="text-xs font-normal text-text-secondary md:text-sm">
            {description}
          </p>
        ) : typeof description === 'string' ? (
          <InfoText text={description} size="sm" maxLength="FULL" />
        ) : (
          description
        ))}
    </div>
  );
}
